/**
 * Whether a Security Insights control row matches the Controls tab search box.
 *
 * Matches the title, the control id, a framework mapping (ref, requirement text or framework label),
 * an affected-scope name (e.g. a device like "axaris-jump"), or the row's findings text. The
 * findings text is what makes Fortinet rows findable by device name: risks created before
 * 29 Oct 2026 carry an AI-written title without the device, but their findings always name it.
 *
 * @param {object} control           a row from GET /security-insights/controls
 * @param {string} query             the search box text
 * @param {(framework: string) => string} [frameworkLabel]  display label for a backend framework key
 */
export function controlMatchesSearch(control, query, frameworkLabel = () => "") {
  if (!query) return true;
  const q = query.toLowerCase();
  const has = (text) => (text || "").toLowerCase().includes(q);

  if (has(control.title) || has(control.controlId)) return true;
  if ((control.frameworkMappings || []).some(m =>
    has(m.ref) || has(m.description) || has(frameworkLabel(m.framework)))) return true;
  if ((control.evidenceDetail?.affectedResources?.examples || []).some(has)) return true;
  return has(control.evidence);
}
